import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Urbaniaforpunetogoatour() {



    const cardData =
    {
        keyword: 'Urbania for Pune to Goa Tour Package',
        heading: 'Urbania on rent in pune: Urbania for Pune to Goa Tour Package',
        headingDescription: 'Urbania On Rent in Pune provides premium and reliable Urbania for Pune to Goa Tour Package services for families, tourists, corporate groups, and event travelers planning trips to the popular beach destination of Goa. Our well-maintained Force Urbania fleet offers spacious seating, air-conditioned comfort, and smooth performance, making it ideal for long-distance travel, weekend getaways, corporate tours, and group sightseeing from Pune to Goa. With professional chauffeurs, flexible one-way and round-trip rental options, and convenient doorstep pickup from major areas including Hinjewadi, Baner, Wakad, Kharadi, Hadapsar, Kothrud, Pimpri Chinchwad, and Pune Airport, we ensure a safe, punctual, and stress-free travel experience. Backed by 24/7 booking support, transparent pricing, and trusted service, Urbania On Rent in Pune stands out as the preferred choice for Urbania hire from Pune to Goa.',

        top: 'Top Places to Visit in Goa with Urbania on rent in pune',


     "topPlaces": [
  {
    "title": "Baga Beach",
    "description": "Baga Beach is one of Goa’s most popular beaches, known for its golden sands, vibrant nightlife, water sports, and beach shacks serving delicious Goan cuisine. Visitors can enjoy parasailing, jet skiing, and dolphin-watching tours, making it ideal for both adventure seekers and those looking to relax by the sea. The sunset here is particularly breathtaking, attracting photographers and tourists alike."
  },
  {
    "title": "Calangute Beach",
    "description": "Calangute Beach, often called the 'Queen of Beaches,' is a lively stretch offering sunbathing, water sports, and a bustling market atmosphere. The beach is surrounded by restaurants, shops, and cafes where visitors can enjoy local seafood and Goan delicacies. It is ideal for families, tourists, and young travelers looking for fun and leisure by the Arabian Sea."
  },
  {
    "title": "Basilica of Bom Jesus",
    "description": "The Basilica of Bom Jesus, a UNESCO World Heritage Site, is famous for housing the mortal remains of St. Francis Xavier. Its baroque architecture, historic significance, and intricate interiors make it a major pilgrimage and tourist attraction. Visitors admire its detailed altars, paintings, and religious ceremonies that reflect Goa’s rich Christian heritage."
  },
  {
    "title": "Fort Aguada",
    "description": "Fort Aguada is a 17th-century Portuguese fort overlooking the Arabian Sea. Known for its historic lighthouse and panoramic coastal views, the fort served as a defense against Dutch and Maratha invasions. Visitors can explore the fortifications, enjoy sea vistas, and learn about Goa’s colonial history. It is a popular spot for photography and history enthusiasts."
  },
  {
    "title": "Dudhsagar Waterfalls",
    "description": "Dudhsagar Waterfalls, one of India’s tallest waterfalls, cascades down the lush Western Ghats amidst dense forests. Accessible via trekking or train rides, the falls create a spectacular view, especially during the monsoon season. Visitors can enjoy nature walks, photography, and the refreshing spray of the waterfall, making it a must-visit natural attraction in Goa."
  },
  {
    "title": "Anjuna Beach and Flea Market",
    "description": "Anjuna Beach is famous for its vibrant party scene, scenic cliffs, and the weekly flea market selling handicrafts, jewelry, and souvenirs. Tourists can enjoy beach parties, live music, and explore the eclectic market, making it a hub for cultural experiences, shopping, and entertainment."
  },
  {
    "title": "Chapora Fort",
    "description": "Chapora Fort, overlooking Vagator Beach, offers panoramic views of the coastline and Arabian Sea. Built by the Portuguese, it is famous for its scenic sunset views and historical significance. Tourists enjoy trekking to the fort, photography, and exploring the surrounding cliffs and beaches."
  },
  {
    "title": "Palolem Beach",
    "description": "Palolem Beach is a crescent-shaped beach known for its calm waters, scenic beauty, and relaxed atmosphere. It is ideal for swimming, kayaking, yoga, and leisure strolls. The beach has numerous shacks serving local cuisine, making it perfect for travelers seeking tranquility away from the busier beaches."
  },
  {
    "title": "Se Cathedral",
    "description": "Se Cathedral is one of the largest churches in Asia, known for its Portuguese-Manueline architecture and historical significance. The church houses the Golden Bell, attracts pilgrims and tourists alike, and hosts religious ceremonies during festivals. Visitors admire its grand interiors, intricate altars, and serene ambiance."
  },
  {
    "title": "Reis Magos Fort",
    "description": "Reis Magos Fort, located on the northern bank of the Mandovi River, is a restored Portuguese fort with a museum showcasing Goa’s colonial history. Visitors can explore the fort, enjoy panoramic views of the river and city, and learn about the region’s military and cultural past, making it a significant heritage attraction."
  }
],



"services": [
    {
      "name": "Urbania for Pune to Goa Tour Package",
      "description": "Urbania for Pune to Goa Tour Package provides well-planned travel solutions for long-distance leisure trips to Goa. Ideal for families, friends, and group travelers, the service ensures spacious seating, professional chauffeurs, safe driving, and well-maintained vehicles, making the journey comfortable, stress-free, and enjoyable while exploring the beaches and attractions of Goa."
    },
    {
      "name": "Pune to Goa Urbania Hire",
      "description": "Pune to Goa Urbania Hire offers convenient and reliable vehicle rentals for intercity travel. Perfect for group tours, corporate trips, and family vacations, the service emphasizes comfort, safety, and punctuality, with trained drivers experienced in long-distance travel ensuring a smooth and hassle-free journey from Pune to Goa."
    },
    {
      "name": "Urbania Bus Rental Pune to Goa",
      "description": "Urbania Bus Rental Pune to Goa provides spacious buses for group travel, corporate tours, and family trips. Equipped with ample seating, safety features, and professional chauffeurs, these buses ensure a comfortable and organized journey, making long-distance travel to Goa simple, safe, and enjoyable for larger groups."
    },
    {
      "name": "Urbania AC Bus Pune to Goa",
      "description": "Urbania AC Bus Pune to Goa offers fully air-conditioned buses for a comfortable long-distance journey. Ideal for corporate teams, families, and tourists, these buses come with climate control, spacious seating, luggage storage, and experienced drivers to ensure a relaxing ride while traveling from Pune to the coastal paradise of Goa."
    },
    {
      "name": "Pune Goa Urbania One Way Hire",
      "description": "Pune Goa Urbania One Way Hire provides flexible travel options for individuals, families, and corporate groups. Vehicles are well-maintained, spacious, and driven by professional chauffeurs, offering a convenient and stress-free journey to Goa without worrying about return trips or scheduling conflicts."
    },
    {
      "name": "Pune Goa Urbania Round Trip Hire",
      "description": "Pune Goa Urbania Round Trip Hire delivers reliable and comfortable round-trip transportation solutions. With professional drivers, punctual service, and clean, well-maintained vehicles, this service ensures travelers can enjoy a hassle-free journey to Goa and back to Pune with safety, comfort, and convenience."
    },
    {
      "name": "Corporate Urbania Pune to Goa",
      "description": "Corporate Urbania Pune to Goa provides professional transportation for business trips, corporate retreats, and events. Vehicles are designed for executive comfort with spacious seating, professional chauffeurs, and timely service, ensuring a seamless and productive travel experience for corporate teams traveling from Pune to Goa."
    },
    {
      "name": "Family Tour Urbania Pune to Goa",
      "description": "Family Tour Urbania Pune to Goa offers safe, spacious, and comfortable vehicles for family vacations and group outings. With courteous chauffeurs, ample luggage space, and well-maintained interiors, families can focus on sightseeing, beach activities, and leisure without worrying about travel logistics."
    },
    {
      "name": "Luxury Urbania Pune to Goa",
      "description": "Luxury Urbania Pune to Goa provides high-end air-conditioned vehicles with plush interiors and superior ride quality for VIPs, executives, and travelers seeking premium comfort. With professional chauffeurs, smooth rides, and attention to detail, this service ensures a luxurious journey to the scenic beaches and attractions of Goa."
    },
    {
      "name": "Affordable Urbania Pune to Goa",
      "description": "Affordable Urbania Pune to Goa delivers cost-effective transportation for families, groups, and budget-conscious travelers. Vehicles are well-maintained, safe, and driven by professional chauffeurs, providing a comfortable and reliable long-distance journey without compromising on quality or comfort."
    },
    {
      "name": "Chauffeur Driven Urbania Pune to Goa",
      "description": "Chauffeur Driven Urbania Pune to Goa offers stress-free travel with trained and verified drivers. Vehicles are spacious, well-maintained, and suitable for long-distance trips, allowing travelers to enjoy a safe, convenient, and comfortable ride from Pune to Goa without worrying about driving or navigation."
    },
    {
      "name": "Pune Goa Urbania Travel Service",
      "description": "Pune Goa Urbania Travel Service provides end-to-end transportation solutions for leisure, corporate, and group travel. With reliable vehicles, experienced chauffeurs, timely service, and assistance with luggage, this service ensures a seamless, comfortable, and enjoyable journey to Goa for all types of travelers."
    },
    {
      "name": "Best Urbania Hire Pune to Goa",
      "description": "Best Urbania Hire Pune to Goa delivers top-rated intercity transportation services focused on reliability, comfort, and customer satisfaction. Ideal for families, corporate teams, and group travelers, this service ensures smooth, safe, and timely travel from Pune to Goa, making it the preferred choice for long-distance trips."
    },
    {
      "name": "Pune to Goa Urbania Booking",
      "description": "Pune to Goa Urbania Booking allows easy and convenient reservation of Urbania vehicles for one-way or round-trip journeys. Travelers can select from various vehicle options to ensure a comfortable, safe, and hassle-free trip from Pune to Goa with professional chauffeur services included."
    },
    {
      "name": "Urbania for Long Tour Package Pune",
      "description": "Urbania for Long Tour Package Pune specializes in transportation for extended leisure trips and multi-day tours. With comfortable vehicles, experienced drivers, and ample luggage capacity, this service ensures a stress-free journey, allowing travelers to explore Goa’s beaches, nightlife, and attractions at their own pace while enjoying maximum comfort."
    }
  ],
  "tableData": [
    ["Urbania for Pune to Goa Tour Package", "Pune to Goa Urbania Hire"],
    ["Urbania Bus Rental Pune to Goa", "Urbania AC Bus Pune to Goa"],
    ["Pune Goa Urbania One Way Hire", "Pune Goa Urbania Round Trip Hire"],
    ["Corporate Urbania Pune to Goa", "Family Tour Urbania Pune to Goa"],
    ["Luxury Urbania Pune to Goa", "Affordable Urbania Pune to Goa"],
    ["Chauffeur Driven Urbania Pune to Goa", "Pune Goa Urbania Travel Service"],
    ["Best Urbania Hire Pune to Goa", "Pune to Goa Urbania Booking"],
    ["Urbania for Long Tour Package Pune", ""]
  ],





"whychoose": [
    {
        "WhyChooseheading": "Reliable Urbania for Pune to Goa Tour Package",
        "WhyChoosedescription": "Urbania for Pune to Goa Tour Package is perfect for comfortable and spacious group travel, ideal for family vacations, corporate trips, weddings, and outstation journeys."
    },
    {
        "WhyChooseheading": "Spacious and Comfortable Force Urbania Vehicles",
        "WhyChoosedescription": "Urbania for Pune to Goa Tour Package provides well-maintained Force Urbania vehicles with ample seating and luggage space, ensuring a smooth and hassle-free journey."
    },
    {
        "WhyChooseheading": "Experienced and Professional Drivers",
        "WhyChoosedescription": "Urbania for Pune to Goa Tour Package comes with skilled drivers familiar with Pune-Goa routes and highways, ensuring safe, timely, and stress-free travel."
    },
    {
        "WhyChooseheading": "Transparent and Affordable Pricing",
        "WhyChoosedescription": "Choose Urbania for Pune to Goa Tour Package for competitive rates with no hidden charges, making long-distance group travel budget-friendly and reliable."
    },
    {
        "WhyChooseheading": "24/7 Booking and Customer Support",
        "WhyChoosedescription": "Urbania for Pune to Goa Tour Package provides round-the-clock assistance for bookings, inquiries, and last-minute travel requirements."
    },
    {
        "WhyChooseheading": "Flexible Tour Packages",
        "WhyChoosedescription": "Urbania for Pune to Goa Tour Package is available for one-way trips, round trips, multi-day tours, corporate travel, wedding transportation, and customized packages."
    },
    {
        "WhyChooseheading": "Clean, Sanitized, and Well-Maintained Vehicles",
        "WhyChoosedescription": "All Urbania vehicles for Pune to Goa trips are regularly cleaned, sanitized, and serviced to ensure a safe and comfortable journey."
    },
    {
        "WhyChooseheading": "Punctual and Reliable Service",
        "WhyChoosedescription": "Urbania for Pune to Goa Tour Package guarantees timely pickups and dependable service, ensuring stress-free and smooth travel."
    }
]
}

const faqData = [
    {
        question: 'Is Urbania for Pune to Goa Tour Package available for local travel as well?',
        answer: 'Yes, Urbania for Pune to Goa Tour Package can also be booked for local travel within Pune or nearby areas, offering a comfortable and spacious ride.',
    },
    {
        question: 'How can I book Urbania for Pune to Goa Tour Package?',
        answer: 'You can book Urbania for Pune to Goa Tour Package via phone, WhatsApp, or online for quick and hassle-free reservations.',
    },
    {
        question: 'Why choose Urbania for Pune to Goa Tour Package for group travel?',
        answer: 'Urbania for Pune to Goa Tour Package provides ample seating, luggage space, and a smooth ride, making it ideal for family, corporate, and group travel.',
    },
    {
        question: 'Is Urbania for Pune to Goa Tour Package suitable for corporate and event travel?',
        answer: 'Yes, it is perfect for corporate trips, airport transfers, weddings, events, and one-way or round-trip tours to Goa.',
    },
    {
        question: 'Are drivers experienced with Urbania for Pune to Goa Tour Package?',
        answer: 'Yes, all drivers are professionally trained, licensed, and experienced in handling Force Urbania vehicles to ensure safe and comfortable travel.',
    },
    {
        question: 'Can I customize pickup and drop-off locations with Urbania for Pune to Goa Tour Package?',
        answer: 'Absolutely. Urbania for Pune to Goa Tour Package allows flexible pickup and drop-off across Pune and Goa.',
    },
    {
        question: 'Is Urbania for Pune to Goa Tour Package available 24x7?',
        answer: 'Yes, Urbania for Pune to Goa Tour Package operates 24x7 to accommodate travel needs at any time.',
    },
    {
        question: 'Are hygiene and safety standards maintained for Urbania for Pune to Goa Tour Package?',
        answer: 'Yes, all vehicles are regularly cleaned, sanitized, and maintained with strict safety protocols for every trip.',
    },
    {
        question: 'What payment options are available for Urbania for Pune to Goa Tour Package?',
        answer: 'Urbania for Pune to Goa Tour Package accepts UPI, digital wallets, credit/debit cards, bank transfers, and corporate billing options.',
    },
    {
        question: 'Is customer support available during the journey?',
        answer: 'Yes, dedicated customer support is available throughout the journey to ensure a smooth and stress-free experience.',
    },
];

const testimonials = [
    {
        id: 1,
        name: 'Mr. Rohit Kulkarni',
        feedback: 'We booked Urbania for Pune to Goa Tour Package for a family vacation. The vehicle was spacious, clean, and extremely comfortable. Excellent service!',
        rating: 5,
    },
    {
        id: 2,
        name: 'Ms. Sneha Patil',
        feedback: 'Urbania for Pune to Goa Tour Package provided amazing service for our corporate trip. The driver was professional and punctual. Highly recommended!',
        rating: 5,
    },
];




























































    const Images = [
        { place: "/images/keyword/1.jpg", text: "Urbania On Rent Pune", link: "urbania-on-rent-pune" },
        { place: "/images/keyword/2.jpg", text: "Urbania on Rent in Pimpri Chinchwad", link: "urbania-on-rent-in-pimpri-chinchwad" },
        { place: "/images/keyword/3.jpg", text: "Urbania Hire for Corporate Events in Pune", link: "urbania-hire-for-corporate-events-in-pune" },
        { place: "/images/keyword/4.jpg", text: "17 Seater Urbania on Rent in Pune", link: "17-seater-urbania-on-rent-in-pune" },
        { place: "/images/keyword/5.jpg", text: "14 Seater Urbania on Rent in Pune", link: "14-seater-urbania-on-rent-in-pune" },
        { place: "/images/keyword/6.jpg", text: "Urbania on Rent in Kharadi", link: "urbania-on-rent-in-kharadi" },
        { place: "/images/keyword/7.jpg", text: "Urbania on Rent in Hadapsar", link: "urbania-on-rent-in-hadapsar" },
        { place: "/images/keyword/8.jpg", text: "Urbania on Rent in Kothrud", link: "urbania-on-rent-in-kothrud" },
        { place: "/images/keyword/9.jpg", text: "Urbania On Rent in Bibwewadi", link: "urbania-on-rent-in-bibwewadi" },
        { place: "/images/keyword/10.jpg", text: "Urbania on Rent in Koregaon Park", link: "urbania-on-rent-in-koregaon-park" },
        { place: "/images/keyword/11.jpg", text: "Urbania On Rent in Kalyani Nagar", link: "urbania-on-rent-in-kalyani-nagar" },
        { place: "/images/keyword/12.jpg", text: "Urbania On Rent in Mundhwa Pune", link: "urbania-on-rent-in-mundhwa-pune" },
        { place: "/images/keyword/13.jpg", text: "Urbania Bus On Rent in Baner", link: "urbania-bus-on-rent-in-baner" },
        { place: "/images/keyword/14.jpg", text: "Urbania AC Bus On Rent in Aundh", link: "urbania-ac-bus-on-rent-in-aundh" },
        { place: "/images/keyword/15.jpg", text: "Urbania Bus On Rent in Hinjewadi", link: "urbania-bus-on-rent-in-hinjewadi" },
        { place: "/images/keyword/16.jpg", text: "Urbania on Rent in Bhosari", link: "urbania-on-rent-in-bhosari" },
        { place: "/images/keyword/17.jpg", text: "Urbania on Rent in Pune Station", link: "urbania-on-rent-in-pune-station" },
        { place: "/images/keyword/18.jpg", text: "Urbania On Rent in Chakan", link: "urbania-on-rent-in-chakan" },
        { place: "/images/keyword/19.jpg", text: "Urbania On Rent in Moshi", link: "urbania-on-rent-in-moshi" },
        { place: "/images/keyword/20.jpg", text: "Urbania On Rent in Charholi Budruk", link: "urbania-on-rent-in-charholi-budruk" },
        { place: "/images/keyword/21.jpg", text: "Urbania On Rent in Nigdi Pradhikaran", link: "urbania-on-rent-in-nigdi-pradhikaran" },
        { place: "/images/keyword/22.jpg", text: "Urbania On Rent in Lohegaon", link: "urbania-on-rent-in-lohegaon" },
        { place: "/images/keyword/23.jpg", text: "Urbania On Rent in Wagholi", link: "urbania-on-rent-in-wagholi" },
        { place: "/images/keyword/24.jpg", text: "Urbania Rental Service in Pune", link: "urbania-rental-service-in-pune" },
        { place: "/images/keyword/25.jpg", text: "Best Urbania on Rent in Pune", link: "best-urbania-on-rent-in-pune" }
    ];












const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Urbania for Pune to Goa Tour Package",
  "image": "https://urbaniaonrentpune.in/assets/images/urbania-pune-to-goa.jpg",
  "description": "Urbania for Pune to Goa Tour Package offers AC and non-AC Urbania bus rental services for one-way and round-trip travel. Perfect for family tours, corporate trips, luxury travel, and long tour packages. Chauffeur-driven Urbania buses ensure comfortable, safe, and affordable journeys from Pune to Goa.",
  "brand": {
    "@type": "Brand",
    "name": "Urbania on Rent in Pune"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "4.9",
    "ratingCount": "950",
    "bestRating": "5",
    "worstRating": "1"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "12000",
    "availability": "https://schema.org/InStock",
    "url": "https://urbaniaonrentpune.in/urbania-pune-to-goa-tour-package"
  }
};






    return (
        <div>
<Helmet>
  <title>
    Call:+91 9209423113 | Urbania for Pune to Goa Tour Package | AC & Luxury Urbania Bus Rental 
  </title>

  <meta
    name="description"
    content="Book Urbania for Pune to Goa Tour Package for one-way or round-trip travel. AC and non-AC Urbania buses for family tours, corporate trips, luxury travel, and long tour packages. Chauffeur-driven service ensures safe and comfortable journeys."
  />

  <meta
    name="keywords"
    content="Urbania for Pune to Goa Tour Package, Pune to Goa Urbania Hire, Urbania Bus Rental Pune to Goa, Urbania AC Bus Pune to Goa, Pune Goa Urbania One Way Hire, Pune Goa Urbania Round Trip Hire, Corporate Urbania Pune to Goa, Family Tour Urbania Pune to Goa, Luxury Urbania Pune to Goa, Affordable Urbania Pune to Goa, Chauffeur Driven Urbania Pune to Goa, Pune Goa Urbania Travel Service, Best Urbania Hire Pune to Goa, Pune to Goa Urbania Booking, Urbania for Long Tour Package Pune"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

            <div
                className="breadcumb-wrapper"
                
                data-overlay="black"
                data-opacity="3"
            >
                <div className="container">
                    <div className="breadcumb-content text-center">
                        <h1 className="breadcumb-title">{cardData.keyword}</h1>
                    </div>
                </div>
            </div>





            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/34.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#183765', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="topPlaces">
                                <p className="sectionLead">{cardData.top}</p>

                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>
                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>



                            <div className="shambhu-services">
                                {cardData.services.map((service, index) => (
                                    <div key={index} className="sh-service-card">

                                        <div className="sh-service-left">
                                            <div className="sh-service-icon">
                                                🚌
                                            </div>
                                        </div>

                                        <div className="sh-service-content">
                                            <h4 className="sh-service-title">{service.name}</h4>
                                            <p className="sh-service-desc">{service.description}</p>
                                        </div>

                                    </div>
                                ))}
                            </div>


                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section" className="why-choose-section">


                                {/* Section Title */}
                                <h2 className="section-title">
                                    Why Choose <span>Urbania On rent in Pune </span>
                                </h2>

                                {/* Cards */}
                                <div className="cards-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div key={index} className="why-card">
                                            <div className="icon-circle">{index + 1}</div>
                                            <h4 className="card-heading">{item.WhyChooseheading}</h4>
                                            <p className="card-desc">{item.WhyChoosedescription}</p>
                                        </div>
                                    ))}
                                </div>
                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Urbania on rent in Pune </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title="Frequently Asked"
                                                    subtitle="Help & Info"
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-telephone-fill"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+919209423113" className="pc-call">+91 9209423113</a>
                                            <a href="tel:+917620411277 " className="pc-call">+91 7620411277 </a>
                                            <a href="tel:+919284718314" className="pc-call">+91 9284718314</a>
                                        </div>

                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/919209423113"
                                                target="_blank" rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp me-1"></i> WhatsApp
                                            </a>
                                            <a href="tel:+919209423113" className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-envelope-fill"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@urbaniaonrentpune.in" className="pc-email">
                                            booking@urbaniaonrentpune.in
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-house-fill"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Urbania on rent in pune</strong><br />
                                            Saket Tata Power CHS, Swami Samarth Marg,
                                            Juhu Nagar, Sector-16, Vashi, Navi Mumbai,
                                            Maharashtra India - 400703
                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Urbaniaforpunetogoatour;